import React, { useEffect, useRef } from 'react';
import classes from './ModalDestinationSchema.module.scss';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { ModalConfig } from 'new/routes/RouterManager';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { PROBE_GET_TREE_REQUEST } from 'js/constants/actionTypes';
import { TableSchema } from 'new/elements/flows/TableSchema';
import { MappingType } from 'new/elements/flows/Databases/useDatabases';

interface ModalPreviewSamplesProps {
  table?: { children: any[]; name: string };
  sourceConnector?: any;
  sinkConnector?: any;
  onChangeMapping?: (map: {}) => void;
  deleteMapping?: (tableName: string) => void;
  mapping?: MappingType[string];
}

export const ModalDestinationSchema = (
  props: ModalPreviewSamplesProps & Partial<ModalOutProps>,
) => {
  const {
    setLoading,
    setModalActions,
    table,
    onChangeMapping,
    deleteMapping,
    mapping,
    sourceConnector,
    sinkConnector,
  } = props;
  const loading = useIsLoading(PROBE_GET_TREE_REQUEST);

  const onSaveSchema = (onConfirm) => {
    if (onConfirm) {
      onConfirm();
    }
  };

  useEffect(() => {
    setModalActions({
      ok: {
        text: 'Done',
        onClick: onSaveSchema,
      },
    });
  }, []);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  return (
    <div className={classes.modalContainer}>
      <TableSchema
        mapping={mapping}
        sourceConnector={sourceConnector}
        sinkConnector={sinkConnector}
        table={table}
        onChangeMapping={onChangeMapping}
        deleteMapping={deleteMapping}
      />
    </div>
  );
};

ModalDestinationSchema.modalConfig = {
  name: 'ModalDestinationSchema',
  title: 'Preview samples',
} as ModalConfig;
